import React, { useState, useEffect, useRef } from "react";
import { components } from "react-select";

import { formatOptionLabel } from "../../Molecules/FormatOptionLabel";
import ModalMotion, {
  AnimateDirection,
} from "@/components/Molecules/ModalMotion";
import Loader from "../../Molecules/Loader";
import {
  Button,
  FlexDiv,
  Label,
  SVGSprite,
  CountryDropdown,
  DropdownIndicator,
  Input,
  Select,
} from "../../Atoms";
import Typography from "@/foundation/Typography/V1";
import theme from "@/foundation/Theme";
import {
  CLUB_VISTARA_ARGUMENT,
  DEFAULT_URL_ARGUMENTS,
} from "../../../utils/Constants";

import { useAppDispatch, useAppSelector } from "@/hooks";

import {
  ArrowDown,
  BodyWrap,
  BoldText,
  CountryPlaceholder,
  DropDown,
  ErrorDiv,
  FormBox,
  InputGroup,
  InputWrap,
  NumberPlaceholder,
  PhoneIcon,
  PromoCode,
  PromoCodeApplyButton,
  RotateCheck,
  SelectGroup,
  SelectIcon,
  StrikeThroughText,
  SubHeading,
} from "./style";
import CTASuccessCallbackView from "../../Molecules/Footer/RightSection";
import {
  saveLead,
  postPackageSave,
  resetNutritionCallbackValues,
} from "@/redux/LandingPageReducer";

const ValueContainer = ({ children, ...props }) => {
  return (
    components.ValueContainer && (
      <components.ValueContainer {...props}>
        {children && (
          <SelectIcon
            icon="icon-dart"
            fill={theme.colors.quote}
            height={"19px"}
            width={"19px"}
          />
        )}
        {children}
      </components.ValueContainer>
    )
  );
};
export const SuccessModal = (props) => {
  const {
    onHideNutritionCallbackModal = () => {},
    showBtn = true,
    data = {},
  } = props || {};

  const showAppDownLoadButtonLink = data?.hero?.show_app_download_links;
  return (
    <FlexDiv
      alignItems={"center"}
      flexDirection={"column"}
      justifyContent={"center"}
      maxWidth={"386px"}
      margin={"0 auto"}
      id="requestCallbackSuccessModal"
      className="callback-message-wrapper"
      aria-labelledby="requestCallbackSuccessModal"
    >
      <RotateCheck
        icon="icon-how-it-work-check"
        height={"45px"}
        width={"45px"}
        fill={theme.colors.textGradient.type3static}
      />
      <Typography
        variant="heading2"
        textAlign="center"
        color={theme.colors.gray_100}
        mb={"35px"}
      >
        {data?.hero?.hero_callback_success_title
          ? data?.hero?.hero_callback_success_title
          : "Thank you for showing interest!"}
      </Typography>
      <Typography
        variant="paragraph1"
        textAlign="center"
        color={theme.colors.gray_100}
        mb={!showBtn ? "0px" : "25px"}
      >
        {data?.hero?.hero_callback_success_subtitle
          ? data?.hero?.hero_callback_success_subtitle
          : "You will get a callback within 24 hours."}
      </Typography>
      {showBtn && (
        <Button
          variant={"primary"}
          onClick={() => onHideNutritionCallbackModal()}
        >
          Okay, thanks!
        </Button>
      )}
      {showAppDownLoadButtonLink && (
        <CTASuccessCallbackView isCTAFormView={true} />
      )}
    </FlexDiv>
  );
};

export const CallBackForm = (props) => {
  const {
    data,
    success,
    error,
    name,
    isLoading,
    handleChange = () => {},
    handleSelectChange = () => {},
    handleBlur = () => {},
    nameError,
    countryCode,
    countryCodes,
    mobileError,
    email,
    mobile,
    emailError,
    companyNameError,
    companyName,
    promoCode,
    promoCodeError,
    promoError,
    promoCodeButtonText,
    promoCodeChecking,
    goal,
    OPTIONS = [],
    goalError,
    onSubmitCallback = () => {},
    showLabels = true,
    programType,
    showEmailField = false,
    applyPromoCode,
    id = undefined,
    isPromoCodeApplied,
    promoCodeData,
    referralCode,
    cvid,
    cvidError,
    showComapnyNameField = false,
    showSelectPackage,
    packageList,
    yogaPackage,
    yogaPackageError,
    isPackageFetching,
    isPazCareYogaPage,
    isJellybeanYogaPage,
    isBainYogaPage,
    isMyGatePage,
    isIndusindYogaPage,
    isVisaNutritionPage,
  } = props || {};
  const [showCountryDropDown, setShowCountryDropDown] = useState(false);
  const onSubmit = (typeLink) => {
    let isFreeTrialFlag = data?.hero?.free_trial_request;
    let isFreeTrail = typeLink ? false : isFreeTrialFlag;

    let state =
      typeof data?.hero?.hero_signup_primary_pricing?.price === "string";

    let isCallbackRequest = !state ? false : !isFreeTrail;

    onSubmitCallback(state, isCallbackRequest, isFreeTrail);
  };
  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setShowCountryDropDown(false);
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);

  return (
    <BodyWrap className={"callback-form-containers"} width={"100%"}>
      <FlexDiv flexDirection={"column"} width={"100%"}>
        {!success && (
          <FlexDiv className="text-center text-error mb-1">{error}</FlexDiv>
        )}

        <FlexDiv flexDirection={"column"} alignItems={"center"} mb={"29px"}>
          <Typography
            variant="heading2"
            mb={"8px"}
            color={theme.colors.gray_100}
            textAlign={"center"}
          >
            {data?.hero?.hero_signup_title
              ? data?.hero?.hero_signup_title
              : "Interested? Request a callback"}
          </Typography>
          <SubHeading variant="paragraph2" textAlign={"center"}>
            {data?.hero?.hero_signup_subtitle
              ? data?.hero?.hero_signup_subtitle
              : " Please leave your details and someone will get in touch within 24hrs!"}
          </SubHeading>
        </FlexDiv>
        <FormBox onSubmit={(e) => e.preventDefault()}>
          <FlexDiv flexDirection={"column"}>
            {showLabels && (
              <Label htmlFor="name">
                <Typography
                  color={theme.colors.gray_80}
                  variant="span"
                  fontFamily={"var(--font-700)"}
                >
                  NAME
                </Typography>
              </Label>
            )}
            <InputGroup showLabels={showLabels}>
              <Input
                type="text"
                placeholder={
                  data?.hero?.hero_signup_name_placeholder
                    ? data?.hero?.hero_signup_name_placeholder
                    : "Enter Your Name"
                }
                name="name"
                value={name}
                onChange={(name) => handleChange(name)}
                onBlur={handleBlur}
                autoComplete="off"
                ref={props.forwardedRef}
                required
                icon="icon-user-face"
                iconFill={theme.colors.quote}
                inputPadding={"12px 15px 12px 40px"}
                iconDimension={"20px"}
                inputFontSize={"16px"}
              />
              {nameError && (
                <ErrorDiv alignItems="center">
                  <SVGSprite
                    icon={"icon-info-icon"}
                    height={"14px"}
                    width={"14px"}
                    fill={theme.colors.red}
                    mr={"7px"}
                  />
                  <Typography
                    variant="span"
                    color={theme.colors.red}
                    fontFamily={"var(--font-700)"}
                  >
                    {nameError}
                  </Typography>
                </ErrorDiv>
              )}
            </InputGroup>
          </FlexDiv>
          {data?.hero?.acceptCVId && (
            <FlexDiv flexDirection={"column"}>
              {showLabels && (
                <Label htmlFor="name">
                  <Typography
                    color={theme.colors.gray_80}
                    variant="span"
                    fontFamily={"var(--font-700)"}
                  >
                    CLUB VISTARA ID
                  </Typography>
                </Label>
              )}
              <InputGroup showLabels={showLabels}>
                <Input
                  type="text"
                  placeholder={
                    data?.hero?.hero_signup_cv_placeholder ||
                    "Enter Club Vistara ID"
                  }
                  name="cvid"
                  value={cvid}
                  onChange={(cvid) => handleChange(cvid)}
                  onBlur={handleBlur}
                  autoComplete="off"
                  ref={props.forwardedRef}
                  required
                  icon="icon-vistara-id"
                  iconFill={theme.colors.quote}
                  inputPadding={"12px 15px 12px 40px"}
                  iconDimension={"25px"}
                  inputFontSize={"16px"}
                />
                {cvidError && (
                  <ErrorDiv alignItems="center">
                    <SVGSprite
                      icon={"icon-info-icon"}
                      height={"14px"}
                      width={"14px"}
                      fill={theme.colors.red}
                      mr={"7px"}
                    />
                    <Typography
                      variant="span"
                      color={theme.colors.red}
                      fontFamily={"var(--font-700)"}
                    >
                      {cvidError}
                    </Typography>
                  </ErrorDiv>
                )}
              </InputGroup>
            </FlexDiv>
          )}
          <FlexDiv flexDirection={"column"}>
            {showLabels && (
              <Label htmlFor="name">
                <Typography
                  variant="span"
                  color={theme.colors.gray_80}
                  fontFamily={"var(--font-700)"}
                >
                  PHONE NUMBER
                </Typography>
              </Label>
            )}

            <InputGroup showLabels={showLabels}>
              <InputWrap>
                <CountryPlaceholder showCountryDropDown={showCountryDropDown}>
                  <NumberPlaceholder
                    onClick={() => setShowCountryDropDown(!showCountryDropDown)}
                    position="relative"
                  >
                    <PhoneIcon
                      icon="icon-phone"
                      fill={theme.colors.quote}
                      height={"19px"}
                      width={"19px"}
                    />
                    <Typography
                      variant="title2"
                      color={theme.colors.placeholderGrey}
                      fontSize={"14px"}
                      fontFamily={"var(--font-500)"}
                      width={"100%"}
                      textAlign={"right"}
                      pr={"5px"}
                    >
                      {countryCode}
                    </Typography>
                    <ArrowDown
                      icon={"icon-arrow-down"}
                      fill={theme.colors.quote}
                      height={"8px"}
                      width={"8px"}
                    />
                  </NumberPlaceholder>
                  <DropDown
                    showCountryDropDown={showCountryDropDown}
                    ref={wrapperRef}
                  >
                    <CountryDropdown
                      menuIsOpen={showCountryDropDown}
                      options={countryCodes?.list}
                      formatOptionLabel={formatOptionLabel}
                      wrapperClassName={"shyftList"}
                      dropDownHeight={"180px"}
                      placeholder={"Search"}
                      defaultValue={countryCode}
                      onChange={(countryCode) => {
                        handleSelectChange("countryCode", countryCode.code);
                        setShowCountryDropDown(false);
                      }}
                      closeMenuOnSelect
                    />
                  </DropDown>
                </CountryPlaceholder>
                <Input
                  inputPadding={"13px 15px 13px 111px"}
                  type="text"
                  placeholder={
                    data?.hero?.hero_signup_mobile_placeholder
                      ? data?.hero?.hero_signup_mobile_placeholder
                      : "Your mobile number"
                  }
                  pattern="[0-9]*"
                  inputMode="decimal"
                  name="mobile"
                  value={mobile}
                  onChange={(mobile) => handleChange(mobile)}
                  onBlur={handleBlur}
                  autoComplete="off"
                  ref={props.forwardedRef}
                  required
                />
              </InputWrap>
              {mobileError && (
                <ErrorDiv alignItems="center">
                  <SVGSprite
                    icon={"icon-info-icon"}
                    height={"14px"}
                    width={"14px"}
                    fill={theme.colors.red}
                    mr={"7px"}
                  />
                  <Typography
                    variant="span"
                    color={theme.colors.red}
                    fontFamily={"var(--font-700)"}
                  >
                    {mobileError}
                  </Typography>
                </ErrorDiv>
              )}
            </InputGroup>
          </FlexDiv>
          {showEmailField && (
            <FlexDiv flexDirection={"column"}>
              {showLabels && (
                <Label htmlFor="name">
                  <Typography
                    color={theme.colors.gray_80}
                    fontFamily={"var(--font-700)"}
                    variant="span"
                  >
                    EMAIL ADDRESS
                  </Typography>
                </Label>
              )}
              <InputGroup showLabels={showLabels}>
                <Input
                  type="email"
                  placeholder={
                    programType === "corporate-partnership"
                      ? "Enter Official Email ID"
                      : "Your email address "
                  }
                  name="email"
                  value={email}
                  onChange={(email) => handleChange(email)}
                  onBlur={handleBlur}
                  autoComplete="off"
                  ref={props.forwardedRef}
                  required
                  icon="icon-envelope"
                  iconFill={theme.colors.quote}
                  inputPadding={"12px 15px 12px 40px"}
                  iconDimension={"20px"}
                  inputFontSize={"16px"}
                />
                {emailError && (
                  <ErrorDiv alignItems="center">
                    <SVGSprite
                      icon={"icon-info-icon"}
                      height={"14px"}
                      width={"14px"}
                      fill={theme.colors.red}
                      mr={"7px"}
                    />
                    <Typography
                      variant="span"
                      color={theme.colors.red}
                      fontFamily={"var(--font-700)"}
                    >
                      {emailError}
                    </Typography>
                  </ErrorDiv>
                )}
              </InputGroup>
            </FlexDiv>
          )}

          {showComapnyNameField && (
            <FlexDiv flexDirection={"column"}>
              {showLabels && (
                <Label htmlFor="companyName">
                  <Typography
                    color={theme.colors.gray_80}
                    fontFamily={"var(--font-700)"}
                    variant="span"
                  >
                    Company Name
                  </Typography>
                </Label>
              )}
              <InputGroup showLabels={showLabels}>
                <Input
                  type="text"
                  placeholder={"Company Name"}
                  name="companyName"
                  value={companyName}
                  onChange={(companyName) => handleChange(companyName)}
                  onBlur={handleBlur}
                  autoComplete="off"
                  ref={props.forwardedRef}
                  required
                  icon="icon-briefcase"
                  iconFill={theme.colors.quote}
                  inputPadding={"12px 15px 12px 40px"}
                  iconDimension={"20px"}
                  inputFontSize={"16px"}
                />
                {companyNameError && (
                  <ErrorDiv alignItems="center">
                    <SVGSprite
                      icon={"icon-info-icon"}
                      height={"14px"}
                      width={"14px"}
                      fill={theme.colors.red}
                      mr={"7px"}
                    />
                    <Typography
                      variant="span"
                      color={theme.colors.red}
                      fontFamily={"var(--font-700)"}
                    >
                      {companyNameError}
                    </Typography>
                  </ErrorDiv>
                )}
              </InputGroup>
            </FlexDiv>
          )}
          {(programType === "nutritionPage" ||
            programType === "healthPage" ||
            programType === "tata-wellness-program" ||
            programType === "ketto-wellness-program" ||
            programType === "hdfc-wellness-program" ||
            programType === "redcliffe_yoga_trial" || //TODO: update the logic
            programType === "yogaPage") && (
            <FlexDiv flexDirection={"column"}>
              {showLabels && (
                <Label htmlFor="name">
                  <Typography
                    color={theme.colors.gray_80}
                    fontFamily={"var(--font-700)"}
                    variant="span"
                  >
                    YOUR GOAL
                  </Typography>
                </Label>
              )}
              <SelectGroup>
                <Select
                  options={OPTIONS || []}
                  dropDownHeight={"150px"}
                  placeholder={"Select a health goal"}
                  name="goal"
                  value={OPTIONS.find((o) => o.value === goal) || ""}
                  onChange={(goal) => handleSelectChange("goal", goal.value)}
                  components={{ ValueContainer, DropdownIndicator }}
                  containerPadding={"12px 15px 12px 40px"}
                  // menuIsOpen
                  dropdownPos={"top"}
                  borderRadius={"10px"}
                  singleValueColor={theme.colors.gray_90}
                  isSearchable={false}
                  minHeight="54px"
                  onBlur={handleBlur}
                />
                {goalError && (
                  <ErrorDiv alignItems="center">
                    <SVGSprite
                      icon={"icon-info-icon"}
                      height={"14px"}
                      width={"14px"}
                      fill={theme.colors.red}
                      mr={"7px"}
                    />
                    <Typography
                      variant="span"
                      color={theme.colors.red}
                      fontFamily={"var(--font-700)"}
                    >
                      {goalError}
                    </Typography>
                  </ErrorDiv>
                )}
              </SelectGroup>
            </FlexDiv>
          )}
          {showSelectPackage && (
            <FlexDiv flexDirection={"column"}>
              {showLabels && (
                <Label htmlFor="name">
                  <Typography
                    color={theme.colors.gray_80}
                    fontFamily={"var(--font-700)"}
                    variant="span"
                  >
                    SELECT PACKAGE
                  </Typography>
                </Label>
              )}
              <SelectGroup>
                <Select
                  options={packageList || []}
                  dropDownHeight={"150px"}
                  placeholder={"Select a package"}
                  name="yogaPackage"
                  value={
                    packageList?.find((o) => o.value === yogaPackage) || ""
                  }
                  onChange={(_package) =>
                    handleSelectChange("yogaPackage", _package.value)
                  }
                  components={{ ValueContainer, DropdownIndicator }}
                  containerPadding={"12px 15px 12px 40px"}
                  // menuIsOpen
                  dropdownPos={"top"}
                  borderRadius={"10px"}
                  singleValueColor={theme.colors.gray_90}
                  isSearchable={false}
                  minHeight="54px"
                  isDisabled={!goal}
                  isLoading={isPackageFetching}
                  instanceId="select-dropdown"
                />
                {yogaPackageError && (
                  <ErrorDiv alignItems="center">
                    <SVGSprite
                      icon={"icon-info-icon"}
                      height={"14px"}
                      width={"14px"}
                      fill={theme.colors.red}
                      mr={"7px"}
                    />
                    <Typography
                      variant="span"
                      color={theme.colors.red}
                      fontFamily={"var(--font-700)"}
                    >
                      {yogaPackageError}
                    </Typography>
                  </ErrorDiv>
                )}
              </SelectGroup>
            </FlexDiv>
          )}
          {data?.hero?.accept_coupon && (
            <FlexDiv flexDirection={"column"}>
              <PromoCode showLabels={showLabels}>
                <Input
                  type="text"
                  placeholder={
                    (isPazCareYogaPage || isJellybeanYogaPage) &&
                    !isBainYogaPage
                      ? "Enter Voucher Code"
                      : isBainYogaPage
                      ? "Enter Coupon Code"
                      : "Enter Promo Code"
                  }
                  name="promoCode"
                  value={promoCode}
                  onChange={(e) => handleChange(e)}
                  onBlur={handleBlur}
                  autoComplete="off"
                  ref={props.forwardedRef}
                  inputColor={
                    isPromoCodeApplied
                      ? theme.colors.link2Color
                      : theme.colors.gray_90
                  }
                  icon={
                    isPromoCodeApplied ? "icon-success-check" : "icon-discount"
                  }
                  iconFill={
                    isPromoCodeApplied
                      ? theme.colors.link2Color
                      : theme.colors.quote
                  }
                  inputPadding={"12px 90px 12px 40px"}
                  iconDimension={"20px"}
                  inputFontSize={"16px"}
                  disabled={isPromoCodeApplied}
                >
                  <PromoCodeApplyButton
                    variant="link"
                    fontSize="13px"
                    TextColor={
                      isPromoCodeApplied || promoCode?.length > 3
                        ? theme.colors.link2Color
                        : theme.colors.quote
                    }
                    onClick={(e) => {
                      e.preventDefault();
                      applyPromoCode();
                    }}
                    fontFamily={"var(--font-700)"}
                  >
                    {promoCodeButtonText}
                    {promoCodeChecking && (
                      <>
                        &nbsp; <Loader />
                      </>
                    )}
                  </PromoCodeApplyButton>
                </Input>
                {promoCodeError && (
                  <ErrorDiv alignItems="center">
                    <SVGSprite
                      icon={"icon-info-icon"}
                      height={"14px"}
                      width={"14px"}
                      fill={theme.colors.red}
                      mr={"7px"}
                    />
                    <Typography
                      variant="span"
                      color={theme.colors.red}
                      fontFamily={"var(--font-700)"}
                      flex={1}
                    >
                      {promoCodeError}
                    </Typography>
                  </ErrorDiv>
                )}
                {promoError && (
                  <FlexDiv alignItems="center">
                    <SVGSprite
                      icon={"icon-info-icon"}
                      height={"14px"}
                      width={"14px"}
                      fill={theme.colors.red}
                      mr={"7px"}
                    />
                    <Typography
                      variant="span"
                      color={theme.colors.red}
                      fontFamily={"var(--font-700)"}
                      flex={1}
                    >
                      {promoError}
                    </Typography>
                  </FlexDiv>
                )}
              </PromoCode>
            </FlexDiv>
          )}
          {data?.hero?.accept_referral && (
            <FlexDiv flexDirection={"column"}>
              <InputGroup showLabels={showLabels}>
                <Input
                  type="text"
                  placeholder={"Enter Referral Code"}
                  name="referralCode"
                  value={referralCode}
                  onChange={(e) => handleChange(e)}
                  onBlur={handleBlur}
                  autoComplete="off"
                  ref={props.forwardedRef}
                  inputColor={theme.colors.gray_90}
                  icon={"icon-discount"}
                  iconFill={theme.colors.quote}
                  inputPadding={"12px 90px 12px 40px"}
                  iconDimension={"20px"}
                  inputFontSize={"16px"}
                />
              </InputGroup>
            </FlexDiv>
          )}
          <FlexDiv justifyContent="center">
            <Button
              variant={"primary"}
              onClick={
                programType === "nutritionPage" ||
                programType === "yogaPage" ||
                programType === "corporate-partnership"
                  ? (e) => {
                      e.preventDefault();
                      onSubmitCallback();
                    }
                  : (e) => {
                      e.preventDefault();
                      onSubmit(false);
                    }
              }
              width={isPromoCodeApplied && promoCodeData ? "100%" : ""}
              btnPadding={
                isPromoCodeApplied && promoCodeData ? "11px 20px" : "11px 40px"
              }
              textAlign={"center"}
              id={id}
              fontSize={"15px"}
            >
              {data?.hero?.hero_cta_title_constant &&
              data?.hero?.hero_signup_primary_pricing?.price ? (
                isPromoCodeApplied && promoCodeData ? (
                  <>
                    {data?.hero?.hero_cta_title_constant + ` `}
                    <StrikeThroughText>
                      {promoCodeData?.original_price}
                    </StrikeThroughText>
                    {` ` + promoCodeData?.new_price}
                  </>
                ) : isPazCareYogaPage ? (
                  <>
                    {data?.hero?.hero_cta_title_constant + ` `}
                    {!isBainYogaPage && !isIndusindYogaPage && (
                      <StrikeThroughText>
                        {data?.hero?.hero_signup_primary_pricing?.price}
                      </StrikeThroughText>
                    )}
                    {` ` +
                      data?.hero?.hero_signup_primary_pricing?.discountedPrice}
                  </>
                ) : isVisaNutritionPage ? (
                  `${data?.hero?.hero_cta_title_constant} ${data?.hero?.hero_signup_primary_pricing?.price}`
                ) : isJellybeanYogaPage ? (
                  <>
                    {data?.hero?.hero_cta_title_constant + ` `}
                    {!isBainYogaPage && (
                      <StrikeThroughText>
                        {data?.hero?.hero_signup_primary_pricing?.price}
                      </StrikeThroughText>
                    )}
                    {` ` +
                      data?.hero?.hero_signup_primary_pricing?.discountedPrice}
                  </>
                ) : (
                  `${data?.hero?.hero_cta_title_constant} ${data?.hero?.hero_signup_primary_pricing?.price}`
                )
              ) : isMyGatePage ? (
                "Book a Free Trial"
              ) : isPazCareYogaPage || isJellybeanYogaPage ? (
                data?.hero?.hero_cta_title_constant
              ) : (
                "Request a callback"
              )}
              {isLoading && (
                <>
                  &nbsp; <Loader />
                </>
              )}
            </Button>
          </FlexDiv>
          {data?.hero?.hero_signup_secondary_pricing?.priceprices?.trial && (
            <FlexDiv alignItems="center" mt={"16px"} flexDirection={"column"}>
              <Typography
                variant="span"
                fontFamily="var(--font-700)"
                color={theme.colors.quote}
                mb={"16px"}
                textAlign="center"
              >
                OR
              </Typography>
              <Button
                hoverColor={`${theme.colors.quote}2e`}
                bgColor={`${theme.colors.quote}2e`}
                variant={"primary1"}
                fontFamily={"var(--font-700)"}
                TextColor={theme.colorsV2.shyft.purple}
                onClick={(e) => {
                  e.preventDefault();
                  onSubmitCallback(true, false, true);
                }}
                btnPadding={"11px 20px"}
                textAlign={"center"}
                id={id}
                fontSize={"15px"}
              >
                {data?.hero?.hero_signup_secondary_cta}
              </Button>
            </FlexDiv>
          )}
          {data?.hero?.hero_signup_trial_class_info && (
            <SubHeading
              mt={"10px"}
              variant="paragraph2"
              textAlign={"center"}
              fontSize={"10px"}
            >
              {data?.hero?.hero_signup_trial_class_info}
            </SubHeading>
          )}
          {data?.hero?.hero_signup_need_more_info && (
            <FlexDiv justifyContent="center" textAlign="center">
              <BoldText
                TextColor={theme.colors.gray_50}
                variant={"link"}
                onClick={(e) => {
                  e.preventDefault();
                  onSubmitCallback(true, true, false);
                }}
                fontFamily={"var(--font-700)"}
              >
                {data?.hero?.hero_signup_need_more_info}
              </BoldText>
            </FlexDiv>
          )}
        </FormBox>
      </FlexDiv>
    </BodyWrap>
  );
};

const CallbackModal = (props) => {
  const {
    countryCodes = [],
    programType = "nutritionPage",
    data = {},
    options = [],
    defaultGoal,
    interactiveOptions,
    isInteractiveClass = false,
  } = props || {};
  const dispatch = useAppDispatch();
  const [inputs, setInputs] = useState({
    name: "",
    countryCode: countryCodes?.default?.code || "+91",
    mobile: "",
    nameError: "",
    mobileError: "",
    email: "",
    emailError: "",
    goal: "",
    goalError: "",
    cvid: "",
    cvidError: "",
  });

  const {
    name,
    countryCode,
    mobile,
    nameError,
    mobileError,
    email,
    emailError,
    goal,
    goalError,
    cvid,
    cvidError,
  } = inputs;

  let ARGUMENTS = data?.hero?.acceptCVId
    ? props.urlParams
      ? `${props.urlParams}${
          props.urlParams.endsWith("&") ? "" : "&"
        }${CLUB_VISTARA_ARGUMENT}`
      : `?${CLUB_VISTARA_ARGUMENT}`
    : props.urlParams || DEFAULT_URL_ARGUMENTS;

  const timezone =
    (typeof Intl !== "undefined" &&
      Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone) ||
    "";
  const OPTIONS = [
    { value: "nutrition-callback-diabetes", label: "Diabetes" },
    { value: "nutrition-callback-highbp", label: "High BP" },
    { value: "nutrition-callback-pcos-d", label: "PCOS/D" },
    { value: "nutrition-callback-pre-postnatal", label: "Post-natal" },
    { value: "nutrition-callback-thyroid", label: "Thyroid" },
    { value: "nutrition-callback-guthealth", label: "Gut-health" },
    { value: "nutrition-callback-others", label: "Others" },
  ];
  const nutritionCallbackData = useAppSelector((state) => state.landingPage);

  const {
    isPaymentLoading: isLoading,
    paymentError: error,
    paymentSuccess: success,
  } = nutritionCallbackData;

  const [formSubmitted, setFormSubmitted] = useState(false);
  const [showModal, setShowModal] = useState(props?.showCallbackModal);
  const [showCallbackSuccessModal, setShowCallbackSuccessModal] =
    useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "name") {
      if ((value.match(/^[a-zA-Z\s]*$/) || value === "") && value.length <= 140)
        setInputs((inputs) => ({ ...inputs, [name]: value }));
    } else if (name === "mobile") {
      if ((value.match(/^[\d -]+$/) || !value) && value.length <= 14) {
        setInputs((inputs) => ({ ...inputs, [name]: value }));
      }
    } else {
      setInputs((inputs) => ({ ...inputs, [name]: value }));
    }
    setInputs((inputs) => ({ ...inputs, [name + "Error"]: "" }));
  };
  const handleSelectChange = (name, value) => {
    setInputs((inputs) => ({ ...inputs, [name]: value }));
    setInputs((inputs) => ({ ...inputs, [name + "Error"]: "" }));
  };

  const handleBlur = (e) => {
    const fieldName = e.target.name;
    const value = e.target.value;
    // if (
    //   (fieldName === "goal" &&
    //     (isValidMobile(inputs?.mobile) || isValidEmail(inputs?.email))) ||
    //   (fieldName === "mobile" && isValidMobile(value)) ||
    //   (fieldName === "email" && isValidEmail(value))
    // ) {
    if (
      (fieldName === "mobile" && value) ||
      (fieldName === "email" &&
        value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i))
    ) {
      dispatch(
        saveLead({
          data: {
            name: name,
            phone: mobile,
            phone_prefix: countryCode,
            ...(email && {
              email,
            }),
            package_slug: goal
              ? goal
              : programType !== "nutritionPage"
              ? defaultGoal
              : isInteractiveClass
              ? "yoga-for-others-ind-49"
              : "nutrition-package-49",
            timezone: timezone,
            urls_arguments: isInteractiveClass
              ? props.urlParams
                ? `${props.urlParams}&${DEFAULT_URL_ARGUMENTS.replace("?", "")}`
                : DEFAULT_URL_ARGUMENTS
              : ARGUMENTS,
            payment_mode: "razorpay",
            is_lead: true,
          },
        })
      );
    }
  };

  const matchCountryRegex = () => {
    if (countryCode?.length === 3) {
      return /^[6-9]\d{9}$/.test(mobile);
    } else if (countryCode?.length === 4) {
      return /^((5){1}([0-9]{8}))/.test(mobile);
    } else if (countryCode?.length === "+1") {
      return /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im.test(
        mobile
      );
    } else {
      return /^((6|8|9){1}([0-9]{7}))/.test(mobile);
    }
  };

  const validateInput = (validateOptionalFields = false) => {
    setInputs({
      ...inputs,
      nameError: "",
      emailError: "",
      phoneError: "",
      dateError: "",
      timeError: "",
      slotDateError: "",
      slotTimeError: "",
      goalError: "",
      cvidError: "",
    });
    if (!name || !mobile || !goal || (data?.hero?.acceptCVId && !cvid)) {
      if (!cvid) {
        setInputs((inputs) => ({
          ...inputs,
          cvidError: "Please enter your Club Vistara ID",
        }));
      }
      if (!name) {
        setInputs((inputs) => ({
          ...inputs,
          nameError: "Please enter your name",
        }));
      }
      if (!matchCountryRegex()) {
        setInputs((inputs) => ({
          ...inputs,
          mobileError: "Please enter a valid phone number",
        }));
        // return false;
      }
      // if (!email) {
      //   setInputs((inputs) => ({
      //     ...inputs,
      //     emailError: "Please enter an email address",
      //   }));
      //   // return false;
      // }
      // if (email && !email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
      //   setInputs((inputs) => ({
      //     ...inputs,
      //     emailError: "Please enter a valid email address",
      //   }));
      //   // return false;
      // }
      if (goal === null || goal === "" || goal === "Select a goal") {
        setInputs((inputs) => ({
          ...inputs,
          goalError: "Please select a health goal",
        }));
      }
      if (name && name.length < 3) {
        setInputs((inputs) => ({
          ...inputs,
          nameError: "Please enter full name",
        }));
        return false;
      }
      return false;
    }
    if (mobile && !matchCountryRegex()) {
      setInputs((inputs) => ({
        ...inputs,
        mobileError: "Please enter a valid number",
      }));
      return false;
    }
    // if (email && !email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
    //   setInputs((inputs) => ({
    //     ...inputs,
    //     emailError: "Please enter a valid email address",
    //   }));
    //   return false;
    // }
    return true;
  };

  const onSubmitCallback = () => {
    if (validateInput()) {
      setFormSubmitted(true);
      let apiData = {
        ...(email && {
          email,
        }),
        is_callback_request: true,
        mobile: mobile,
        name: name,
        package_slug: goal,
        payment_mode: "razorpay",
        phone_prefix: countryCode,
        urls_arguments: isInteractiveClass
          ? props.urlParams
            ? `${props.urlParams}&${DEFAULT_URL_ARGUMENTS.replace("?", "")}`
            : DEFAULT_URL_ARGUMENTS
          : ARGUMENTS,
        timezone: timezone,
      };
      dispatch(postPackageSave({ data: apiData }));
    }
  };

  const onHideNutritionCallbackModal = () => {
    dispatch(resetNutritionCallbackValues());
    setInputs({
      ...inputs,
      name: "",
      mobile: "",
      countryCode: countryCodes?.default?.code || "+91",
      email: "",
      goal: "",
      cvid: "",
      cvidError: "",
    });
    setShowModal(false);
    setShowCallbackSuccessModal(false);
    props.hideModal();
  };

  useEffect(() => {
    if (success) {
      setShowCallbackSuccessModal(true);
    }
  }, [nutritionCallbackData]);

  return (
    <>
      <ModalMotion
        overlayClosable
        onClose={onHideNutritionCallbackModal}
        width={"582px"}
        animateDirection={AnimateDirection.CENTER}
        borderRadius={"10px"}
        showClose
        iconTopPosition={"20px"}
        iconRightPosition={"20px"}
      >
        {showModal && !success && (
          <CallBackForm
            data={data}
            success={success}
            error={error}
            name={name}
            handleChange={handleChange}
            handleSelectChange={handleSelectChange}
            handleBlur={handleBlur}
            nameError={nameError}
            countryCode={countryCode}
            mobileError={mobileError}
            email={email}
            mobile={mobile}
            emailError={emailError}
            goal={goal}
            goalError={goalError}
            onSubmitCallback={onSubmitCallback}
            OPTIONS={
              programType === "nutritionPage"
                ? isInteractiveClass
                  ? interactiveOptions
                  : OPTIONS
                : options
            }
            isLoading={isLoading}
            countryCodes={countryCodes}
            programType={programType}
            cvid={cvid}
            cvidError={cvidError}
          />
        )}
        {success && showCallbackSuccessModal && (
          <SuccessModal
            onHideNutritionCallbackModal={onHideNutritionCallbackModal}
            data={null}
          />
        )}
      </ModalMotion>
    </>
  );
};

export default CallbackModal;
